import getTopics from 'services/apiHelpers/getTopics';
import getStore from 'services/getStore';
import { updateInteractionsOpenAction } from 'store/next';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';
import onScrollEnds from 'services/onScrollEnds';
import { subscriptionExchange } from 'urql';

const store = getStore();

const navToNextTopic = () => {
  const topics = getTopics();
  const nextTopic =
    topics[topics.findIndex(t => t.id === getCurrentTopic().id) + 1];

  if (!nextTopic) return;

  setCurrentTopic(nextTopic.id);

  window.scrollTo(0, 0);
};

const next = (sId, id) => l => {
  if (l !== 'next') {
    // window.USE_UPDATED_NAV
    // if (window.sessionStorage.getItem('USE_UPDATED_NAV') === 'true') {

    // updated. always true ( < remove later )

    // we're setting this in module.tsx onHashChange
    // const currentTopic = getCurrentTopic();
    // const locationHistory = `${currentTopic.props.sId ||
    //   currentTopic.id}/${sId || id}`;
    // window.locationHistory = locationHistory;

    // console.log({ l });

    window.location.hash = l;

    // old way
    // } else {
    //   window.locationHistory = `${getCurrentTopic().id}/${id}`;
    //   setCurrentTopic(l);
    // }

    return;
  }

  requestAnimationFrame(
    () =>
      (window.location.hash = Math.random()
        .toString(16)
        .substr(2, 8))
  );

  window.locationHistory = null;

  store.dispatch(updateInteractionsOpenAction(id));
  // console.log(store.getState().interactionsOpen);

  const getNextInteraction = () => {
    // testing this
    const interactions = Array.from(document.querySelectorAll('section'));
    // Array.from(document.querySelectorAll('[data-section]'));

    const nextInteraction: any =
      interactions[interactions.findIndex(i => i.id === `i${id}`) + 1];

    // if (nextInteraction) {
    //   store.dispatch({
    //     type: 'UPDATE_INTERACTIONS_SEEN',
    //     data: {
    //       id: nextInteraction.id,
    //     },
    //   });
    // }

    return nextInteraction;
  };

  requestAnimationFrame(() => {
    // const interactions = Array.from(
    //   document.querySelectorAll('[data-section]')
    // );

    // const nextInteraction: any =
    //   interactions[interactions.findIndex(i => i.id === `i${id}`) + 1];
    const nextInteraction = getNextInteraction();

    if (nextInteraction) {
      nextInteraction.scrollIntoView({
        behavior: 'smooth',
      });

      onScrollEnds(() => {
        // requestAnimationFrame(() => nextInteraction.focus());

        // store.dispatch({
        //   type: 'UPDATE_INTERACTIONS_SEEN',
        //   data: {
        //     id: nextInteraction.id.replace(/i/, ''),
        //   },
        // });

        nextInteraction.focus();
      });
    } else {
      navToNextTopic();
    }

    // nextInteraction
    //   ? nextInteraction.scrollIntoView({
    //       behavior: 'smooth',
    //     })
    //   : navToNextTopic();
  });
};

export default next;
